<template>
  <base-popup v-if="alertToshow" popupStyle="alert" :disabled="true">
    <template #header>
      <h3>{{ alertToshow.title }}</h3>
    </template>
    <template #bodyContent>
      <div v-if="Array.isArray(alertToshow.message)" class="alert-message-list">
        <div v-for="message in alertToshow.message" :key="message" :style="getMessageStyle(message)">
          {{ getMessage(message) }}
        </div>
      </div>
      <div v-else :style="getMessageStyle(alertToshow.message)">
        {{ getMessage(alertToshow.message) }}
      </div>
    </template>
    <template #footer>
      <button v-if="alertToshow.promise.rejecter" @click="cancel()" class="cancel-button">
        {{ alertToshow.cancelMessage ? alertToshow.cancelMessage : "Annuler" }}
      </button>
      <div v-else><!-- block vide pour aligner les boutons --></div>
      <button v-if="alertToshow.promise.resolver" @click="confirm()" class="confirm-button">
        {{ alertToshow.validateMessage ? alertToshow.validateMessage : "Valider" }}
      </button>
      <div v-else><!-- block vide pour aligner les boutons --></div>
    </template>
  </base-popup>
</template>

<script>
import BasePopup from './Base/BasePopup.vue'
import * as namespaceStore from "../../vuexStore/namespaceStore.js";
import { mapGetters, mapMutations } from "vuex";
import * as mutations from "../../vuexStore/mutations.js";

export default {
  name: 'AlertPopup',
  props: {
  },
  components: {
    BasePopup
  },
  computed: {
    ...mapGetters(namespaceStore.MESSAGE, [
      "alert"
    ]),
    alertToshow: {
      get() {
        if (this.alert.length > 0) {
          return this.alert[0];
        }
        return null;
      },
    }
  },
  methods: {
    ...mapMutations(namespaceStore.MESSAGE, {
      removeAlert: mutations.REMOVE_ALERT
    }),
    getMessage(message) {
      if (typeof message == "object" && message.text) {
        return message.text;
      }
      return message;
    },
    getMessageStyle(message) {
      if (typeof message == "object" && message.text) {
        return message.style;
      }
      return {};
    },
    cancel() {
        if (this.alertToshow.promise && this.alertToshow.promise.rejecter)
            this.alertToshow.promise.rejecter(false);
        this.removeAlert(this.alertToshow.id);
        this.$emit('close');
    },
    confirm() {
      if (this.alertToshow.promise && this.alertToshow.promise.resolver) {
        this.alertToshow.promise.resolver(true);
      }
      this.removeAlert(this.alertToshow.id);
      this.$emit('confirm');
    }
  }
}
</script>

<style scoped>
.alert-message-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.confirm-button {
  padding: 0.5rem 1rem;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.375rem;
  color: #e5e7eb;
  font-weight: 500;
  transition: all 0.2s ease;
}

.confirm-button:hover {
  background-color: rgba(255, 255, 255, 0.15);
}

.cancel-button {
  padding: 0.5rem 1rem;
  background-color: rgba(239, 68, 68, 0.2);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 0.375rem;
  color: #ef4444;
  font-weight: 500;
  transition: all 0.2s ease;
}

.cancel-button:hover {
  background-color: rgba(239, 68, 68, 0.3);
  border-color: #ef4444;
}
</style> 